<template>
    <a class="btn btn-white"
       :href="supportUrl"
       target="_blank"
       data-analytics-id="Help"
       @click="click">
        <i class="fa-solid fa-message-question fa-fw"></i>
        {{ l('NAV.HELP') }}
    </a>
</template>

<script>
import { container } from '@/container';

export default {
    emits: [
        'done',
    ],

    computed: {
        supportUrl() {
            return container.appConfig.supportUrl;
        },
    },

    methods: {
        click() {
            this.$emit('done');
        },
    },
};
</script>
